import { render, staticRenderFns } from "./RequireLogin.vue?vue&type=template&id=87e97bac"
import script from "./RequireLogin.vue?vue&type=script&lang=js"
export * from "./RequireLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports